import { Component, OnInit } from '@angular/core';
import { BankingAccountItemService } from '../banking-account-item.service';
import { BankingAccountItem } from '../banking-account-item';
import { Router } from '@angular/router';
import { NotificationService } from '../../../../shared/notification.service';

@Component({
  selector: 'app-banking-account-item-create',
  templateUrl: 'create.component.html',
})
export class BankingAccountItemCreateComponent implements OnInit {
  /**
   * Details of the accountItem being created.
   */
  public accountItem: BankingAccountItem;

  /**
   * Are we currently performing a loading action?
   *
   * @item {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {BankingAccountItemService} accountItemService
   * @param {NotificationService} notificationService
   * @param {Router} router
   */
  constructor(
    private accountItemService: BankingAccountItemService,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.accountItemService.loading.subscribe(
      result => (this.isLoading = result),
    );
  }

  /**
   * Initialise the component, creating a new blank accountItem if required.
   */
  public ngOnInit(): void {
    if (!this.accountItem) {
      this.accountItem = new BankingAccountItem();
    }
  }

  /**
   * Perform the create action which adds the new accountItem into the backend.
   */
  public create() {
    const createBankingAccountItem = this.accountItemService
      .createBankingAccountItem(this.accountItem)
      .subscribe(
        (result: BankingAccountItem) => {
          this.notificationService.success(
            `BankingAccountItem Created`,
            `New item has been created with ID of ${
              result.id
            }.`,
            5,
          );
          this.accountItem = new BankingAccountItem();
          createBankingAccountItem.unsubscribe();
          this.router.navigate(['/banking/account-items']);
        },
        err => {
          this.notificationService.error(
            `Could not create BankingAccountItem`,
            err.error.message,
            10,
          );
        },
      );
  }
}
